var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefCommercial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.391 59.4785V63.3916C63.391 64.8263 62.2171 66.0003 60.7823 66.0003H11.2171C9.78231 66.0003 8.6084 64.8263 8.6084 63.3916V59.4785H63.391Z",
    fill: "#E9E7F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.522 36.0003V39.9133C42.522 40.6307 41.935 41.2177 41.2176 41.2177H30.7829C30.0655 41.2177 29.4785 40.6307 29.4785 39.9133V34.6959C29.4785 33.9786 30.0655 33.3916 30.7829 33.3916H41.2176C41.935 33.3916 42.522 33.9786 42.522 34.6959V36.0003Z",
    fill: "#7100DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.739 7.30435V9.91304C47.739 10.6304 47.152 11.2174 46.4347 11.2174H25.5651C24.8477 11.2174 24.2607 10.6304 24.2607 9.91304V7.30435C24.2607 6.58696 24.8477 6 25.5651 6H46.4347C47.152 6 47.739 6.58696 47.739 7.30435Z",
    fill: "#7100DA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.478 39.913C29.478 40.6304 30.0649 41.2174 30.7823 41.2174H41.2171C41.9345 41.2174 42.5214 40.6304 42.5214 39.913V36H63.391V59.4783H8.6084V36H29.478V39.913Z",
    fill: "#E9E7F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66 20.348V33.3914C66 34.8262 64.8261 36.0001 63.3913 36.0001H42.5217V34.6958C42.5217 33.9784 41.9348 33.3914 41.2174 33.3914H30.7826C30.0652 33.3914 29.4783 33.9784 29.4783 34.6958V36.0001H8.6087C7.17391 36.0001 6 34.8262 6 33.3914V20.348C6 18.9132 7.17391 17.7393 8.6087 17.7393H63.3913C64.8261 17.7393 66 18.9132 66 20.348Z",
    fill: "#CEC6EF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4778 11.2178H26.8691V17.7395H29.4778V11.2178Z",
    fill: "#303030"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1302 11.2178H42.5215V17.7395H45.1302V11.2178Z",
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefCommercial);
export default __webpack_public_path__ + "static/media/ref-commercial.c87e1758986c9d3245617526208cde42.svg";
export { ForwardRef as ReactComponent };